/**
 * @class Oskari.framework.bundle.oskariui.Layout
 *
 *
 */
Oskari.clazz.define('Oskari.framework.bundle.oskariui.Layout',
/**
 * @static constructor function
 */
function () {}, {
  /**
  * @method applyLayout
  * applies this layout with given DomManager
  */
  applyLayout: function applyLayout() {},
  /**
  * @method removeLayout
  */
  removeLayout: function removeLayout() {}
}, {
  'protocol': ['Oskari.dom.Layout']
});